<section class="left">
	<div>
		<button class="ficon-arrow-left back-btn" role="button" aria-label="back" (click)="onBack.emit()"></button>
	</div>

	<div class="message">
		<h1 translate="sign-up_student-signup-message-title"></h1>
		<p [innerHTML]="'sign-up_student-signup-message' | translate"></p>
	</div>
</section>

<section class="right">
	<img class="image" src="https://staticassets.goreact.com/astronaut-astroid.svg" alt="message">
</section>
